import React, { useEffect, useState } from 'react';
import { Row, Col, Checkbox, Select, Radio, Space, Card } from 'antd';
import { WorkType } from '../../../common/enums';
import { getProcessInfo } from '../../../common/CommonAPI';
import { getTitleForKey, kouteiMasterTypes } from '../../../common/Common';
import { type } from '@testing-library/user-event/dist/type';

const SurfaceTreatmentPanel = (props) => {
  const [isUsed, setIsUsed] = useState(true);

  const [deviceInfo, setDeviceInfo] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [platingOptions, setPlatingOptions] = useState([]);
  const [paintingOptions, setPaintingOptions] = useState([]);

  // plat
  const [platingOne, setPlatingOne] = useState(0);
  const [platingTwo, setPlatingTwo] = useState(0);
  // paint
  const [paintingOne, setPaintingOne] = useState(0);
  const [paintingTwo, setPaintingTwo] = useState(0);

  const [typeOne, setTypeOne] = useState('none');
  const [typeTwo, setTypeTwo] = useState('none');

  const [treatmentData, setTreatmentData] = useState({
    stage1: { type: 'none', deviceId: null, side: 'one-side' },
    stage2: { type: 'none', deviceId: null, side: 'one-side' },
  });

  useEffect(() => {
    if (props.processMasterData || props.deviceMasterData) {
      const hyoumenProcess = props?.processMasterData.filter((i) => i.workType === WorkType.SmSurface);
      if (hyoumenProcess) {
        const hyoumenDevices = props?.deviceMasterData.filter((device) => device.processId === hyoumenProcess[0].id);

        settingMasterData(hyoumenProcess[0].id);
        const formattedDevices = hyoumenDevices.map((device) => ({
          id: device.id,
          name: device.name,
        }));

        setDeviceInfo(formattedDevices);
        if (props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen) {
          setSelectedDevice(props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.id || 0);
          setTypeOne(props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.typeOne || 0);
          setTypeTwo(props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.typeTwo || 0);
          setPlatingOne(props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.platingOne || 0);
          setPlatingTwo(props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.platingTwo || 0);
          setPaintingOne(props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.paintingOne || 0);
          setPaintingTwo(props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.paintingTwo || 0);
          setTreatmentData((prev) => ({
            ...prev,
            stage1: {
              ...prev.stage1,
              side: props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.sideOne || 0,
            },
            stage2: {
              ...prev.stage1,
              side: props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.sideTwo || 0,
            },
          }));
        } else if (formattedDevices.length > 0) {
          setSelectedDevice(formattedDevices[0].id);
        }
      }
    }
  }, [props.processMasterData, props.deviceMasterData]);

  const settingMasterData = async (processId) => {
    const kouteiMasterDataDB = await getProcessInfo();
    const kouteiMasterData = getKouteiMasterRelatedInfo(kouteiMasterDataDB);

    const processGroup = kouteiMasterData.find((m) => m.id === processId)?.processDetail;

    if (processGroup && processGroup.length > 0) {
      for (let i = 0; i < processGroup.length; i++) {
        const processDetailTitle = processGroup[i].processDetailTitle;

        if (processDetailTitle.includes('メッキ')) {
          const formattedPlatDevices = processGroup[i].processDetailValue.map((device) => ({
            id: device.id,
            name: device.name,
          }));

          setPlatingOptions(formattedPlatDevices);
          if (!props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.platingOne) {
            setPlatingOne(formattedPlatDevices[0]?.id || 0);
          }
          if (!props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.platingTwo) {
            setPlatingTwo(formattedPlatDevices[0]?.id || 0);
          }
        }

        if (processDetailTitle.includes('塗装')) {
          const formattedPaintDevices = processGroup[i].processDetailValue.map((device) => ({
            id: device.id,
            name: device.name,
          }));

          setPaintingOptions(formattedPaintDevices);
          if (!props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.paintingOne) {
            setPaintingOne(formattedPaintDevices[0]?.id || 0);
          }
          if (!props?.selectedIQ5DataForHyoumen?.processSelect?.hyoumen?.paintingTwo) {
            setPaintingTwo(formattedPaintDevices[0]?.id || 0);
          }
        }
      }
    }
  };

  const getKouteiMasterRelatedInfo = (kouteiDBData) => {
    let kouteiMasterInfo = [];

    kouteiDBData?.forEach((e) => {
      let newRecord = { ...e };
      newRecord.relatedClass = e.class === 0 ? '親部品' : e.class === 1 ? 'IQ3' : 'IQ5';
      newRecord.isAdditionalRelated = e.isAdditional ? '追加' : '標準';
      let matchType = kouteiMasterTypes?.find((type) => type.workType === e.workType);
      newRecord.relatedType = matchType ? matchType.typeName : null;
      let count = 0;
      let groupedTypes = e.details.processDetailTypes?.reduce((result, type) => {
        if (!result[type.group]) {
          result[type.group] = [];
        }
        result[type.group].push(type);
        return result;
      }, {});

      newRecord.processDetail = Object.keys(groupedTypes)?.map((key, subIndex) => {
        const processDetailTitleObj = getTitleForKey(key, matchType);
        return {
          group: parseInt(key),
          processDetailTitle: processDetailTitleObj.detailName,
          defaultRow: processDetailTitleObj?.defaultRow || 0,
          processDetailValue: groupedTypes[key],
        };
      });
      kouteiMasterInfo.push(newRecord);
    });
    return kouteiMasterInfo;
  };

  const handleDeviceChange = (value) => {
    setSelectedDevice(value);
    const data = {
      id: value,
      isUsed: isUsed,
      platingOne: platingOne,
      platingTwo: platingTwo,
      paintingOne: paintingOne,
      paintingTwo: paintingTwo,
      typeOne: typeOne,
      typeTwo: typeTwo,
      sideOne: treatmentData.stage1.side,
      sideTwo: treatmentData.stage2.side,
    };
    props?.updateHyoumenData(data);
  };

  const handlePlateOneChange = (value) => {
    setPlatingOne(value);
    const data = {
      id: selectedDevice,
      isUsed: isUsed,
      platingOne: value,
      platingTwo: platingTwo,
      paintingOne: paintingOne,
      paintingTwo: paintingTwo,
      typeOne: typeOne,
      typeTwo: typeTwo,
      sideOne: treatmentData.stage1.side,
      sideTwo: treatmentData.stage2.side,
    };
    props?.updateHyoumenData(data);
  };

  const handlePlateTwoChange = (value) => {
    setPlatingTwo(value);
    const data = {
      id: selectedDevice,
      isUsed: isUsed,
      platingOne: platingOne,
      platingTwo: value,
      paintingOne: paintingOne,
      paintingTwo: paintingTwo,
      typeOne: typeOne,
      typeTwo: typeTwo,
      sideOne: treatmentData.stage1.side,
      sideTwo: treatmentData.stage2.side,
    };
    props?.updateHyoumenData(data);
  };

  const handlePaintOneChange = (value) => {
    setPaintingOne(value);
    const data = {
      id: selectedDevice,
      isUsed: isUsed,
      platingOne: platingOne,
      platingTwo: platingTwo,
      paintingOne: value,
      paintingTwo: paintingTwo,
      typeOne: typeOne,
      typeTwo: typeTwo,
      sideOne: treatmentData.stage1.side,
      sideTwo: treatmentData.stage2.side,
    };
    props?.updateHyoumenData(data);
  };

  const handlePaintTwoChange = (value) => {
    setPaintingTwo(value);
    const data = {
      id: selectedDevice,
      isUsed: isUsed,
      platingOne: platingOne,
      platingTwo: platingTwo,
      paintingOne: paintingOne,
      paintingTwo: paintingTwo,
      typeOne: typeOne,
      typeTwo: typeTwo,
      sideOne: treatmentData.stage1.side,
      sideTwo: treatmentData.stage2.side,
    };
    props?.updateHyoumenData(data);
  };

  const handleSideChange1 = (e) => {
    const newSide = e.target.value;
    setTreatmentData((prev) => ({
      ...prev,
      stage1: {
        ...prev.stage1,
        side: newSide,
      },
    }));

    const data = {
      id: selectedDevice,
      isUsed: isUsed,
      platingOne: platingOne,
      platingTwo: platingTwo,
      paintingOne: paintingOne,
      paintingTwo: paintingTwo,
      typeOne: typeOne,
      typeTwo: typeTwo,
      sideOne: newSide,
      sideTwo: treatmentData.stage2.side,
    };
    props?.updateHyoumenData(data);
  };

  const handleSideChange2 = (e) => {
    const newSide = e.target.value;
    setTreatmentData((prev) => ({
      ...prev,
      stage2: {
        ...prev.stage2,
        side: newSide,
      },
    }));
    const data = {
      id: selectedDevice,
      isUsed: isUsed,
      platingOne: platingOne,
      platingTwo: platingTwo,
      paintingOne: paintingOne,
      paintingTwo: paintingTwo,
      typeOne: typeOne,
      typeTwo: typeTwo,
      sideOne: treatmentData.stage1.side,
      sideTwo: newSide,
    };
    props?.updateHyoumenData(data);
  };

  const handleTypeOneChange = (e) => {
    const newType = e.target.value;

    setTypeOne(newType);
    const data = {
      id: selectedDevice,
      isUsed: isUsed,
      platingOne: platingOne,
      platingTwo: platingTwo,
      paintingOne: paintingOne,
      paintingTwo: paintingTwo,
      typeOne: newType,
      typeTwo: typeTwo,
      sideOne: treatmentData.stage1.side,
      sideTwo: treatmentData.stage2.side,
    };
    props?.updateHyoumenData(data);
  };

  const handleTypeTwoChange = (e) => {
    const newType = e.target.value;

    setTypeTwo(newType);

    const data = {
      id: selectedDevice,
      isUsed: isUsed,
      platingOne: platingOne,
      platingTwo: platingTwo,
      paintingOne: paintingOne,
      paintingTwo: paintingTwo,
      typeOne: typeOne,
      typeTwo: newType,
      sideOne: treatmentData.stage1.side,
      sideTwo: treatmentData.stage2.side,
    };
    props?.updateHyoumenData(data);
  };

  return (
    <div>
      <fieldset style={{ border: '1px solid #d9d9d9', padding: '10px', borderRadius: '4px' }}>
        <legend style={{ fontSize: '14px', width: 'auto', padding: '0 5px', marginBottom: 0 }}>表面処理</legend>

        <Row align="middle" style={{ marginBottom: '20px' }}>
          <Col span={4}>
            <Checkbox checked={isUsed} onChange={(e) => setIsUsed(e.target.checked)}>
              Used:
            </Checkbox>
          </Col>
          <Col span={12}>
            <Select
              value={selectedDevice}
              style={{ width: '100%' }}
              onChange={handleDeviceChange}
              options={deviceInfo.map((device) => ({
                value: device.id,
                label: device.name,
              }))}
            />
          </Col>
        </Row>

        <div style={{ marginBottom: '10px' }}>表面処理</div>

        <Row gutter={16}>
          <Col span={12}>
            <Card
              title={<div style={{ textAlign: 'center', color: 'white' }}>第1処理</div>}
              headStyle={{ backgroundColor: '#5b71f3', minHeight: '30px', padding: '0' }}
              bodyStyle={{ padding: '15px' }}
              style={{ width: '100%', borderColor: '#a5a5a5' }}
              className="testCard"
            >
              <Radio.Group value={typeOne || 'none'} onChange={handleTypeOneChange} style={{ width: '100%' }}>
                <Space direction="vertical" style={{ width: '100%' }}>
                  <Radio value="none">無し</Radio>
                  <Radio value="degreasing">脱脂</Radio>

                  {/* --- Plating (メッキ) Row --- */}
                  <Row align="middle">
                    <Col span={10}>
                      <Radio value="plating">メッキ</Radio>
                    </Col>
                    <Col span={14}>
                      <Select
                        value={platingOne}
                        style={{ width: '100%' }}
                        onChange={handlePlateOneChange}
                        options={platingOptions.map((device) => ({
                          value: device.id,
                          label: device.name,
                        }))}
                      />
                    </Col>
                  </Row>

                  {/* --- Painting (塗装) Row --- */}
                  <Row align="middle">
                    <Col span={10}>
                      <Radio value="painting">塗装</Radio>
                    </Col>
                    <Col span={14}>
                      <Select
                        value={paintingOne}
                        style={{ width: '100%' }}
                        onChange={handlePaintOneChange}
                        options={paintingOptions.map((device) => ({
                          value: device.id,
                          label: device.name,
                        }))}
                      />
                    </Col>
                  </Row>

                  {/* --- Side Selection (両面 / 片面) --- */}
                  <div style={{ paddingLeft: '25px', marginTop: '5px', paddingBottom: '23px' }}>
                    <Radio.Group
                      disabled={typeOne !== 'painting'}
                      value={treatmentData.stage1.side || 'one-side'}
                      onChange={handleSideChange1}
                    >
                      <Space direction="vertical">
                        <Radio value="both-sides">両面</Radio>
                        <Radio value="one-side">片面</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                </Space>
              </Radio.Group>
            </Card>
          </Col>
          <Col span={12}>
            <Card
              title={<div style={{ textAlign: 'center', color: 'white' }}>第2処理</div>}
              headStyle={{ backgroundColor: '#5b71f3', minHeight: '30px', padding: '0' }}
              bodyStyle={{ padding: '15px' }}
              style={{ width: '100%', borderColor: '#a5a5a5' }}
              className="testCard"
            >
              <Radio.Group value={typeTwo || 'none'} onChange={handleTypeTwoChange} style={{ width: '100%' }}>
                <Space direction="vertical" style={{ width: '100%' }}>
                  <Radio value="none">無し</Radio>
                  <Radio value="degreasing">脱脂</Radio>

                  {/* --- Plating (メッキ) Row --- */}
                  <Row align="middle">
                    <Col span={10}>
                      <Radio value="plating">メッキ</Radio>
                    </Col>
                    <Col span={14}>
                      <Select
                        value={platingTwo}
                        style={{ width: '100%' }}
                        onChange={handlePlateTwoChange}
                        options={platingOptions.map((device) => ({
                          value: device.id,
                          label: device.name,
                        }))}
                      />
                    </Col>
                  </Row>

                  {/* --- Painting (塗装) Row --- */}
                  <Row align="middle">
                    <Col span={10}>
                      <Radio value="painting">塗装</Radio>
                    </Col>
                    <Col span={14}>
                      <Select
                        value={paintingTwo}
                        style={{ width: '100%' }}
                        onChange={handlePaintTwoChange}
                        options={paintingOptions.map((device) => ({
                          value: device.id,
                          label: device.name,
                        }))}
                      />
                    </Col>
                  </Row>

                  {/* --- Side Selection (両面 / 片面) --- */}
                  <div style={{ paddingLeft: '25px', marginTop: '5px', paddingBottom: '23px' }}>
                    <Radio.Group
                      disabled={typeTwo !== 'painting'}
                      value={treatmentData.stage2.side || 'one-side'}
                      onChange={handleSideChange2}
                    >
                      <Space direction="vertical">
                        <Radio value="both-sides">両面</Radio>
                        <Radio value="one-side">片面</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                </Space>
              </Radio.Group>
            </Card>
          </Col>
        </Row>
      </fieldset>
    </div>
  );
};

export default SurfaceTreatmentPanel;
